import palette from './palette';

const {
  jade,
  elephant,
  raven,
  chateau,
  zircon,
  porcelain,
  smoke,
  athens,
  pearlLusta,
  brand,
  scotchMist,
  permission
} = palette;

export default {
  primary: jade,
  link: '#121277',
  radio: {
    background: '#FFF',
    border: '#BEBEBE',
    backgroundSelected: '#647dfc',
    borderSelected: '#2C90FC',
    backgroundDisabled: '#F6F6F6',
    borderDisabled: '#CCC',
    shadow: 'rgba(0,0,0,0.20)',
    shadowDisabled: 'rgba(0,0,0,0.10)'
  },
  input: {
    disabled: '#f1f1f1'
  },
  base: {
    white: '#FFF',
    black: '#000',
    default: '#333',
    gray: '#979797',
    grayDarkest: '#676767',
    grayDark: '#636363',
    grayMedium: '#A8A8A8',
    grayLight: '#D9D9D9',
    grayLightest: '#F1F1F1',
    blueDarker: '#097093',
    blue: '#0a84ae',
    blueLight: '#44c7f4',
    blueLightest: '#f5f7f9',
    orange: '#eb5424',
    orangeLighter: '#ff784d',
    orangeLightest: '#ffb299',
    orangeDark: '#FF3E00',
    greenDarker: '#3F6910',
    green: '#4CD964',
    red: '#FF0000',
    redDarker: '#801F00',
    yellow: '#786600'
  },
  text: {
    primary: elephant,
    secondary: raven,
    disabled: chateau,
    placeholder: raven
  },
  icon: {
    primary: raven,
    secondary: elephant
  },
  border: {
    primary: zircon,
    secondary: porcelain,
    hover: elephant,
    active: brand,
    disabled: porcelain,
    error: permission
  },
  background: {
    primary: porcelain,
    hover: smoke,
    disabeld: smoke,
    error: permission
  },
  layout: {
    asidePane: athens
  },
  components: {
    table: {
      selection: pearlLusta
    },
    railNavigation: {
      backgroundColor: '#12244d',
      brandBackground: 'rgb(4, 21, 56)',
      activeColor: '#fff',
      activeBackground: '#425378'
    },
    alert: {
      background: scotchMist
    }
  },
  setting: '#f7f7f8',
  group: '#fbfbfb',
  success: '#34dc67',
  links: '#9494ba',
  faded: '#666',
  fadedExtra: '#888',
  brand: '#1F9999',
  lightgrey: '#dadfe3',
  nearWhite: '#ebeef0',
  grey: '#e8e8ef',
  helptext: '#7b7b7b',
  black: '#000',
  'black-color': '#000',
  secondary: '#e0e5ff',
  white: '#ffffff',
  'white-color': '#ffffff',
  'instruction-color': '#ffa037',
  'error-color': '#ff5959',
  'success-color': '#1ab394',

  'link-color': '#0d6dbe',
  'link-color-1': '#229bde',

  'text-color': '#525456',
  'text-color-1': '#183247',
  'text-color-2': '#a0a3b3',

  'placeholder-color': '#c0c0c0',

  'label-color': '#737c85',
  'current-label-color': '#4990e2',
  'span-color-1': '#676a6c',
  'heading-color': '#3c4f63',
  'header-toggle-color': '#9aa1a6',
  'breadcrumb-color': '#757575',
  'other-page-content-color': '#697379',
  'product-title-color': '#666666',
  'demo-link-color': '#88929d',

  'footer-color': '#525556',
  'footer-link-color': '#3b7adb',

  /* Button and button state change colours */
  'primary-btn-color': '#7e7efc',
  'primary-btn-box-shadow': '#567890',
  'primary-btn-hover': '#5050f6',
  'cancel-btn-color': 'rgb(230, 230, 230)',
  'cancel-btn-box-shadow': 'rgb(222, 222, 222)',
  'cancel-btn-hover': 'rgb(222, 222, 222)',

  /* Background and border colours */
  'main-background': '#f9f9f9',
  'sidebar-background': '#353752',
  'error-background': '#ff595912',
  'bg-color-1': '#6acd29',
  'bg-color-2': '#ffa700',
  'bg-color-3': '#be63c5',
  'bg-color-4': '#d23c4e',
  'bg-color-5': '#43c9ee',
  'bg-color-6': '#3278b1',
  'border-color-1': '#d8d8d8',
  'border-color-2': '#f2f2f2',
  'border-color-3': '#d3dbda',
  'border-color-4': '#eaeaea',
  'border-color-5': '#d4d4d4',
  'success-background': '#dff0d8',
  'warning-background': '#fcf8e3',
  'warning-color': '#8a6d3b',
  'info-background': '#d9edf7',
  'info-color': '#31708f',
  'success-btn-color': '#28a745',
  'success-btn-box-shadow': '#1e7e34',
  'success-btn-hover': '#218838',
  'danger-btn-color': '#dc3545',
  'danger-btn-box-shadow': '#bd2130',
  'danger-btn-hover': '#c82333',
  'warning-btn-color': '#ffc107',
  'warning-btn-box-shadow': '#d39e00',
  'warning-btn-hover': '#e0a800',
  'info-btn-color': '#17a2b8',
  'info-btn-box-shadow': '#117a8b',
  'info-btn-hover': '#138496',
  'light-forecolor': '#646464',
  'light-btn-color': '#f6f6ff',
  'light-btn-box-shadow': '#dae0e5',
  'light-btn-hover': '#e2e6ea',
  'list-item-bullet-color': '#cacaca',
  'highlight-blue': 'rgb(27,106,251)'
};
